import { DocumentViewer, Spinner } from '../../../..';
import React, { useEffect, useState } from 'react';
import { IDocumentDetailProps } from './document-detail.types';
import * as S from '../claim-timeline.styles';


export const DocumentDetail: React.FunctionComponent<IDocumentDetailProps> = (
    props: IDocumentDetailProps
): React.ReactElement => {
    const { document, appType, onLoadDocumentUrl, loading: externalLoading = false } = props;
    
    const [internalLoading, setInternalLoading] = useState(false);
    const [documentUrl, setDocumentUrl] = useState<string | undefined>();
    
    const loading = externalLoading || internalLoading;

    useEffect(() => {
        (async (): Promise<void> => {
            if (document && document.id) {
                setInternalLoading(true);
                try {
                    const url = await onLoadDocumentUrl(document.id, document.documentType);
                    setDocumentUrl(url?.url);
                } finally {
                    setInternalLoading(false);
                }
            }
        })();
    }, [document, onLoadDocumentUrl]);

    return (
        <S.ExpandContainer>
            {loading ? (
                <Spinner />
            ) : (
                <>
                    {/* App-Specific Fields */}
                    {appType === 'provider' && (
                        <S.ExpandTable>
                            <S.ExpandTBody>
                                <S.ExpandTR>
                                    <S.ExpandTD>{document.description}</S.ExpandTD>
                                </S.ExpandTR>
                            </S.ExpandTBody>
                        </S.ExpandTable>
                    )}
                    
                    {appType === 'support' && (
                        <S.ExpandTable>
                            <S.ExpandTBody>
                                <S.ExpandTR>
                                    <S.ExpandTH>ID</S.ExpandTH>
                                    <S.ExpandTD>{document.id}</S.ExpandTD>
                                </S.ExpandTR>
                                <S.ExpandTR>
                                    <S.ExpandTH>Description</S.ExpandTH>
                                    <S.ExpandTD>{document.description}</S.ExpandTD>
                                </S.ExpandTR>
                                <S.ExpandTR>
                                    <S.ExpandTH>Type</S.ExpandTH>
                                    <S.ExpandTD>{document.documentType}</S.ExpandTD>
                                </S.ExpandTR>
                                <S.ExpandTR>
                                    <S.ExpandTH>Filename</S.ExpandTH>
                                    <S.ExpandTD>{document.filename}</S.ExpandTD>
                                </S.ExpandTR>
                            </S.ExpandTBody>
                        </S.ExpandTable>
                    )}

                    {/* Document Preview */}
                    {documentUrl && <DocumentViewer url={documentUrl} />}
                </>
            )}
        </S.ExpandContainer>
    );
};
